<template>
  <main-layout
    margin-top="8px"
    desktop
  >
    <drafts-container />
  </main-layout>
</template>

<script>
import DraftsContainer from '@/components/Widgets/DraftsContainer';

export default {
  components: {
    DraftsContainer,
  },
};
</script>
